"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staffCapabilityOverrideSchema = exports.staffCapabilitySchema = exports.STAFF_CAPABILITIES = void 0;
const zod_1 = require("zod");
exports.STAFF_CAPABILITIES = [
    "assigned_jobs:read",
    "job_status:update",
    "time_tracking:read_self",
    "time_tracking:write",
    "job_notes:write",
    "job_photos:write",
    "job_checklists:write",
    "assigned_customer_contacts:read",
    "prices:read",
    "job_line_items:write",
    "estimates:create",
    "payments:collect",
    "schedule:read_all",
    "customers:read_all",
    "leads:read_all",
    "communications:read",
    "chats:read",
    "chats:manage",
    "job_inbox:read",
    "job_inbox:manage",
    "job_inbox:assign",
    "job_inbox:convert",
    "job_inbox:dismiss",
    "inbox_settings:manage",
    "lead_channels:read",
    "lead_channels:manage",
    "lead_sources:read",
    "lead_sources:manage",
    "api_leads:manage",
    "service_areas:read",
    "service_areas:manage",
    "estimates:read_all",
    "invoices:read_all",
    "payment_disputes:read",
    "payment_disputes:manage",
    "compensation:read",
    "compensation:manage",
    "compensation:approve",
    "compensation:read_self",
    "voice:use",
];
exports.staffCapabilitySchema = zod_1.z.enum(exports.STAFF_CAPABILITIES);
exports.staffCapabilityOverrideSchema = zod_1.z.object({
    capability: exports.staffCapabilitySchema,
    enabled: zod_1.z.boolean(),
});
//# sourceMappingURL=staff-capability.js.map